import BaseService from 'services/BaseService';

/**
 * @extends BaseService
 */
export default class TrueFalseAnswerService extends BaseService {
	/**
	 * @type {string}
	 * @private
	 */
	_type = 'trueFalseAnswerMode';
	/**
	 * @type {string}
	 * @private
	 */
	_typeKey = 'mode';

	/**
	 * @param {LogService} logService
	 */
	constructor(logService) {
		super();

		/**
		 * @type {LogService}
		 * @private
		 */
		this._logService = logService;
	}

	/**
	 * @param {Object} answer
	 * @returns {Object|undefined}
	 */
	toModel(answer) {
		try {
			return super.toModel(answer);
		} catch (error) {
			this._logService.warn(error);
		}
	}
}
